import React, {useMemo} from "react";
import {AppSimplifiedShell} from "../../../component/app-simplified-shell";
import {useBooking} from "../../../context/booking";
import {isBlank} from "../../../utils";
import {Alert, Button, Typography} from "@mui/material";
import {useLocalization} from "../../../i18n";
import {useNavigate} from "react-router-dom";
import {BookingView} from "./booking-view";

export function BookingDetailsSimplified() {
	const navigate = useNavigate();
	const {t} = useLocalization();
	const {booking} = useBooking();

	/**
	 * Booking is paid when it either:
	 * - does not contain a payment id
	 * - payment status is equals to paid
	 */
	const isPaid = useMemo(() =>
			booking !== undefined && (isBlank(booking.paymentId) || booking.paymentStatus === 'paid')
		, [booking]);

	return (
		<AppSimplifiedShell>
			{!isPaid && (
				<>
					<Typography textAlign="center" variant="h1" gutterBottom>{t('booking.simplified.title')}</Typography>
					<Alert
						severity="warning"
						action={
							<Button
								variant="contained"
								color="primary"
								onClick={() => navigate(`/${booking?.tenant.id}/bookings/${booking?.id}/payment`)}
							>
								{t('actions.pay')}
							</Button>
						}
					>
						{t('payment.completePaymentPrompt')}
					</Alert>
				</>
			)}
			{isPaid && <BookingView />}
		</AppSimplifiedShell>
	)
}
